import { useState, useCallback } from "react";

import { FeedbackQuestionsResponse } from "../candidate-feedback.types";
import { CandidateFeedbackHttpService } from "../candidate-feedback-http.service";

export function useCandidateFeedback() {
  const [data, setData] = useState<FeedbackQuestionsResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchQuestions = useCallback(async (inviteId: number) => {
    setIsLoading(true);
    setError(null);

    try {
      const data = await CandidateFeedbackHttpService.getQuestions(inviteId);
      setData(data);
      return data;
    } catch (error) {
      setError("Failed to load feedback questions");
      return null;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    fetchQuestions,
    data,
    isLoading,
    error,
  };
}
